import BaseValidator from './BaseValidator';

class EducationItemValidator extends BaseValidator {
  validationErrors: any[];
  validity: any;
  university_name: any;
  course_name: any;
  degree: any;
  year_from: any;
  year_to: any;
  constructor(opts: any = {}) {
    super();
    this.validationErrors = [];
    this.validity = null;
    this.university_name = opts.university_name;
    this.course_name = opts.course_name;
    this.degree = opts.degree;
    this.year_from = opts.year_from;
    this.year_to = opts.year_to;
  }

  validate() {
    const validityCheck = Promise.all([
      this.validateUniversity(),
      this.validateCourse(),
      this.validateYearRange(),
      this.validateDegree(),
    ]).then((responses) => {
      if (this.validationErrors.length === 0) {
        return Promise.resolve({ valid: true });
      } else {
        return Promise.resolve({ valid: false, errors: this.validationErrors });
      }
    });
    return validityCheck;
  }

  dealValidationResult(type, res) {
    if (res.success) {
      return res;
    } else {
      this.validationErrors.push({
        success: false,
        type: type,
        message: res.err,
      });
      return res;
    }
  }

  validateUniversity() {
    return super.cannotEmpty(this.university_name).then((res) => {
      this.dealValidationResult('University Name', res);
    });
  }

  validateCourse() {
    return super.cannotEmpty(this.course_name).then((res) => {
      this.dealValidationResult('Course', res);
    });
  }

  validateYearRange() {
    Promise.all([
      super.cannotEmpty(this.year_from),
      super.cannotEmpty(this.year_to),
    ]).then((results: any[]) => {
      if (results[0].success && results[1].success) {
        return this.checkYearRangeFormat(results).then((res) => {
          this.dealValidationResult('Duration of Degree', res);
        });
      } else {
        this.dealValidationResult('Duration of Degree', {
          success: false,
          err: 'Both fields cannot be empty.',
        });
      }
    });
  }

  validateDegree() {
    return super.cannotEmpty(this.degree).then((res) => {
      this.dealValidationResult('Degree', res);
    });
  }

  checkYearRangeFormat(results) {
    return new Promise((resolve, reject) => {
      if (results[0].value > results[1].value) {
        resolve({
          success: false,
          err: 'Gradudation year should be after the entrance year.',
        });
      } else {
        resolve({ success: true });
      }
    });
  }
}

export default EducationItemValidator;
